import React from 'react';
import DsButton from '../../common/DsButton';
import DsModal from '../../common/DsModal';

export default function EventDetailsNotificationParticipantModals({ view }) {
  const {
    AdminMemberProfileModal,
    ExplanationButton,
    addNotificationSilenceDraft,
    closeManualParticipantModal,
    getParticipantImageStyle,
    handleAddManualParticipant,
    manualParticipantCandidates,
    manualParticipantLoading,
    manualParticipantModalOpen,
    manualParticipantSavingId,
    manualParticipantSearch,
    notificationSilenceDrafts,
    notificationSilenceModalOpen,
    notificationSilenceSaving,
    participantProfile,
    removeNotificationSilenceDraft,
    saveNotificationSilence,
    setManualParticipantSearch,
    setNotificationSilenceModalOpen,
    setParticipantProfile,
    updateNotificationSilenceDraft,
  } = view;

  return (
    <>
          <DsModal
            open={notificationSilenceModalOpen}
            onClose={() => {
              setNotificationSilenceModalOpen(false);
            }}
            title="通知サイレント時間"
            size="lg"
            className="event-notification-silence-modal"
            dismissible={!notificationSilenceSaving}
            footer={(
              <div className="event-notification-silence-modal__footer">
                <DsButton
                  variant="secondary"
                  onClick={addNotificationSilenceDraft}
                  disabled={notificationSilenceDrafts.length >= 12}
                >
                  <i className="fa-solid fa-plus" aria-hidden="true"></i>
                  <span>時間を追加</span>
                </DsButton>
                <DsButton
                  block
                  onClick={saveNotificationSilence}
                  disabled={notificationSilenceSaving}
                  loading={notificationSilenceSaving}
                >
                  保存
                </DsButton>
              </div>
            )}
          >
                <p className="event-notification-silence-modal__lead">
                  本番中など、対象イベントに関係するアーティストへのイベント関連PUSHを音・バイブなしにします。イベントチャットのメンション通知だけは通常通知として届きます。緊急の直接連絡は個別チャット、または対象者をメンションしたイベントチャットを使ってください。
                </p>

                <div className="event-notification-silence-list">
                  {notificationSilenceDrafts.map((item, index) => (
                    <div className="event-notification-silence-window" key={item.id || index}>
                      <div className="event-notification-silence-window__head">
                        <strong>サイレント時間 {index + 1}</strong>
                        <div className="event-notification-silence-window__actions">
                          <label className="event-notification-silence-toggle">
                            <input
                              type="checkbox"
                              checked={item.enabled !== false}
                              onChange={(e) => updateNotificationSilenceDraft(index, 'enabled', e.target.checked)}
                            />
                            <span>有効</span>
                          </label>
                          <button
                            type="button"
                            className="event-notification-silence-remove"
                            onClick={() => removeNotificationSilenceDraft(index)}
                            aria-label={`サイレント時間 ${index + 1} を削除`}
                          >
                            <i className="fa-solid fa-trash" aria-hidden="true"></i>
                          </button>
                        </div>
                      </div>

                      <div className="event-notification-silence-grid">
                        <label>
                          <span className="event-notification-silence-label">
                            名称
                            <ExplanationButton
                              title="名称"
                              body="複数枠を区別するための任意メモです。例: 昼公演、夜公演、ゲネプロ。"
                              buttonClassName="event-notification-silence-help-action"
                            />
                          </span>
                          <input
                            type="text"
                            value={item.label || ''}
                            onChange={(e) => updateNotificationSilenceDraft(index, 'label', e.target.value)}
                            placeholder="例: 昼公演"
                          />
                        </label>

                        <label>
                          <span className="event-notification-silence-label">
                            開始日時
                            <ExplanationButton
                              title="開始日時"
                              body="この時刻以降、イベント関連通知を静音PUSHへ切り替えます。イベントチャットのメンション通知だけは通常通知として届きます。入力は日本時間です。"
                              buttonClassName="event-notification-silence-help-action"
                            />
                          </span>
                          <input
                            type="datetime-local"
                            value={item.silentStartsAt || ''}
                            onChange={(e) => updateNotificationSilenceDraft(index, 'silentStartsAt', e.target.value)}
                          />
                        </label>

                        <label>
                          <span className="event-notification-silence-label">
                            終了日時
                            <ExplanationButton
                              title="終了日時"
                              body="この時刻を過ぎると通常通知に戻ります。入力は日本時間です。"
                              buttonClassName="event-notification-silence-help-action"
                            />
                          </span>
                          <input
                            type="datetime-local"
                            value={item.silentEndsAt || ''}
                            onChange={(e) => updateNotificationSilenceDraft(index, 'silentEndsAt', e.target.value)}
                          />
                        </label>
                      </div>

                      <div className="event-notification-silence-sound-check">
                        <label className="event-notification-silence-toggle">
                          <input
                            type="checkbox"
                            checked={item.soundCheckEnabled === true}
                            onChange={(e) => updateNotificationSilenceDraft(index, 'soundCheckEnabled', e.target.checked)}
                          />
                          <span>
                            本番前アプリデバイスサウンド・バイブレーションチェック
                            <ExplanationButton
                              title="本番前チェック通知"
                              body="本番前にスマホのサウンド・バイブ設定を確認するためのPUSHです。通知文言は「間も無く本番です。サイレントモードまたは電源OFFにして下さい。」で、3通を数秒間隔で連続送信します。先頭2通は数秒後にアプリ側で削除を試み、最後の1通だけ10分後に削除を試みます。メール、LINE、チャット投稿は行いません。"
                              buttonClassName="event-notification-silence-help-action"
                            />
                          </span>
                        </label>
                        {item.soundCheckEnabled ? (
                          <label className="event-notification-silence-sound-check__time">
                            <span className="event-notification-silence-label">チェック通知日時</span>
                            <input
                              type="datetime-local"
                              value={item.soundCheckScheduledAt || ''}
                              onChange={(e) => updateNotificationSilenceDraft(index, 'soundCheckScheduledAt', e.target.value)}
                            />
                          </label>
                        ) : null}
                      </div>
                    </div>
                  ))}
                  {!notificationSilenceDrafts.length ? (
                    <div className="event-notification-silence-empty">サイレント時間は未設定です。</div>
                  ) : null}
                </div>

          </DsModal>
          <DsModal
            open={manualParticipantModalOpen}
            onClose={closeManualParticipantModal}
            title="契約なし参加アーティストを追加"
            size="sm"
            className="event-manual-participant-modal"
          >
                <p className="event-manual-participant-modal__lead">
                  追加したアーティストは、契約参加者と同じくイベント情報の閲覧とイベントチャット参加が可能になります。後から契約を作成すると、契約が正本となりこの追加は自動で解除されます。
                </p>
                <input
                  type="search"
                  className="event-manual-participant-search"
                  value={manualParticipantSearch}
                  onChange={(e) => setManualParticipantSearch(e.target.value)}
                  placeholder="アーティスト名で検索"
                  autoFocus
                />
                <div className="event-manual-participant-list">
                  {manualParticipantLoading ? (
                    <div className="event-manual-participant-empty">検索中…</div>
                  ) : manualParticipantCandidates.length === 0 ? (
                    <div className="event-manual-participant-empty">追加できる候補がありません。</div>
                  ) : (
                    manualParticipantCandidates.map((artist) => {
                      const artistId = String(artist.artist_id || '');
                      const saving = manualParticipantSavingId === artistId;
                      return (
                        <div className="event-manual-participant-candidate" key={artistId}>
                          <div className="participant-identity">
                            <div className="participant-avatar" style={getParticipantImageStyle(artist)}>
                              {!artist.profile_picture && (artist.name || '').charAt(0)}
                            </div>
                            <div className="participant-main">
                              <div className="participant-name">{artist.name || artist.name_en || '名称未設定'}</div>
                              {artist.name_en ? (
                                <div className="event-manual-participant-sub">{artist.name_en}</div>
                              ) : null}
                            </div>
                          </div>
                          <DsButton
                            size="sm"
                            className="event-manual-participant-add"
                            onClick={() => handleAddManualParticipant(artist)}
                            disabled={saving || Boolean(manualParticipantSavingId)}
                            loading={saving}
                          >
                            追加
                          </DsButton>
                        </div>
                      );
                    })
                  )}
                </div>
          </DsModal>
          {participantProfile ? (
            <AdminMemberProfileModal
              type="artist"
              artist={participantProfile}
              onClose={() => setParticipantProfile(null)}
            />
          ) : null}
    </>
  );
}
